var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorPicker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6489_26261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM12 15.7895C9.90713 15.7895 8.21053 14.0929 8.21053 12C8.21053 9.90713 9.90713 8.21053 12 8.21053C14.0929 8.21053 15.7895 9.90713 15.7895 12C15.7895 14.0929 14.0929 15.7895 12 15.7895Z",
    fill: "#D8D8DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2636 8.84202H23.5796C22.739 5.75267 20.6961 3.15898 17.9836 1.5957L10.7373 8.84202H13.2636Z",
    fill: "#D4B6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7365 8.84212L17.9828 1.59581C16.2216 0.580781 14.1785 0 11.9997 0C10.9066 0 9.84816 0.146953 8.8418 0.420844V10.7369L10.7365 8.84212Z",
    fill: "#EBAFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84197 10.7369V0.420898C5.75263 1.26146 3.15894 3.30441 1.5957 6.01693L8.84192 13.2632V10.7369H8.84197Z",
    fill: "#E07188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8418 10.7365L10.7365 8.84184H13.2628V8.8418H10.7365L8.8418 10.7365Z",
    fill: "#D8D8DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7365 15.1574L8.8418 13.2627L10.7365 15.1574H13.2628L15.1575 13.2627L13.2628 15.1574H10.7365Z",
    fill: "#D8D8DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5788 8.8418H13.2627L13.3076 8.84184L15.1574 10.7365L22.4037 17.9828C23.4188 16.2216 23.9996 14.1785 23.9996 11.9997C23.9996 10.9066 23.8526 9.84806 23.5788 8.8418Z",
    fill: "#B4D8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1582 13.2631V23.5791C18.2475 22.7386 20.8412 20.6955 22.4044 17.9831L15.1582 10.7368V13.2631Z",
    fill: "#ACFFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2628 15.1579L6.0166 22.4042C7.77774 23.4193 9.82084 24 11.9997 24C13.0928 24 14.1512 23.8531 15.1576 23.5792V13.2632L13.2628 15.1579Z",
    fill: "#95D5A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.737 15.1577H0.420898C1.26155 18.2471 3.30451 20.8407 6.01702 22.404L13.2633 15.1577H10.737Z",
    fill: "#F8E99B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84212 13.2634L1.59586 6.01709C0.580734 7.77828 0 9.82137 0 12.0002C0 13.0933 0.146953 14.1518 0.42075 15.1581H10.7368L8.84212 13.2634Z",
    fill: "#EFC27B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3076 8.84229H13.2627L15.1574 10.737L13.3076 8.84229Z",
    fill: "#D8D8DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5792 8.84202C22.7386 5.75267 20.6956 3.15898 17.9831 1.5957L12 7.57883V8.84197H13.2631H23.5792V8.84202Z",
    fill: "#B681D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9831 1.59581C16.2219 0.580781 14.1788 0 12 0V7.57894L17.9831 1.59581Z",
    fill: "#E592BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.4211V24C13.0931 24 14.1515 23.8531 15.1579 23.5792V13.2632L13.2631 15.1579L12 16.4211Z",
    fill: "#80CB93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2631 15.1577H12V16.4209L13.2631 15.1577Z",
    fill: "#F6E27D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6489_26261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPicker);
export default __webpack_public_path__ + "static/media/color-picker.7e1136385d44beb80619203081ec3848.svg";
export { ForwardRef as ReactComponent };